import dashboard from './modules/dashboard'
import BasicLayout from '@/layouts/basic-layout'

import org from './modules/org'
import bpm from './modules/bpm'
import notice from './modules/notice'
import news from './modules/news'
import website from './modules/website'
import sys from './modules/sys'
import schedule from './modules/schedule'
import bpmAdmin from './modules/bpmAdmin'
import tax from './modules/tax'
import leading_examining from '../hospital/leading_examining'
import body_symptoms from '../hospital/body_symptoms'
import symptoms_described from '../hospital/symptoms_described'
import symptoms_described_submit from '../hospital/symptoms_described_submit'
import symptoms_described_calculate from '../hospital/symptoms_described_calculate'

/* 商务报表 */
import businessReport from './modules/businessReport'

/**
 * 在主框架内显示
 */

const frameIn = [
  {
    path: '/',
    name: 'home',
    redirect: {
      name: 'dashboard-console',
    },
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: 'index',
        redirect: {
          name: 'dashboard-console',
        },
      },
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '前端日志',
          auth: false,
        },
        component: () => import('@/pages/system/log'),
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: {
          beforeRouteEnter(to, from, next) {
            next((instance) => instance.$router.replace(from.fullPath))
          },
          render: (h) => h(),
        },
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: {
          beforeRouteEnter(to, from, next) {
            next((instance) =>
              instance.$router.replace(JSON.parse(from.params.route))
            )
          },
          render: (h) => h(),
        },
      },
      //  智能导诊
      {
        path: 'LeadingExamining',
        name: 'leading_examining',
        component: () => import('@/hospital/leading_examining'),
      },
      {
        path: 'BodySymptoms',
        name: 'body_symptoms',
        component: () => import('@/hospital/body_symptoms'),
      },
      {
        path: 'SymptomsDescribed',
        name: 'symptoms_described',
        component: () => import('@/hospital/symptoms_described'),
      },
      {
        path: 'SymptomsDescribedSubmit',
        name: 'symptoms_described_submit',
        component: () => import('@/hospital/symptoms_described_submit'),
      },
      {
        path: 'SymptomsDescribedCalculate',
        name: 'symptoms_described_calculate',
        component: () => import('@/hospital/symptoms_described_calculate'),
      },
    ],
  },
  dashboard,
  org,
  bpm,
  notice,
  news,
  website,
  sys,
  schedule,
  bpmAdmin,
  tax,
  businessReport,
]

/**
 * 在主框架之外显示
 */

const frameOut = [
  // 官网
  {
    path: '/websites',
    name: 'websites',
    meta: {
      auth: false,
      title: '$t:page.account.website',
    },
    component: () => import('@/pages/account/website'),
  },
  // 登录
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '$t:page.login.title',
    },
    component: () => import('@/pages/account/login'),
  },
  {
    path: '/website',
    name: 'websites',
    meta: {
      title: '$t:page.website.title',
    },
    component: () => import('@/pages/account/website'),
  },
  // 注册
  {
    path: '/register',
    name: 'register',
    meta: {
      title: '$t:page.register.title',
    },
    component: () => import('@/pages/account/register'),
  },
  // 注册结果
  {
    path: '/register/result',
    name: 'register-result',
    meta: {
      auth: true,
      title: '注册结果',
    },
    component: () => import('@/pages/account/register/result'),
  },
  // 详情组件用户信息展示
  {
    path: '/user/details/:id',
    name: 'userDetails',
    meta: {
      title: '$t:menu.userDetails',
    },
    component: () => import('@/pages/dashboard/user/userAbDetails.vue'),
  },
  // 测试界面
  {
    path: '/test',
    name: 'test',
    meta: {
      title: '测试界面',
    },
    component: () => import('@/components/ab-cust-dialog/test.vue'),
  },
  {
    path: '/findPwdByEmail',
    name: 'findPwdByEmail',
    meta: {
      title: '$t:page.revpwd.title',
    },
    component: () => import('@/pages/account/findPwdByEmail'),
  },

  // 重置密码
  {
    path: '/updatePwd/:username/:password',
    name: 'updatePwd',
    meta: {
      title: '$t:page.respwd.title',
    },
    component: () => import('@/pages/account/updatePwd'),
  },
  // 打印页
  {
    path: '/bpm/instance/printDialog',
    name: 'printDialog',
    meta: {
      title: '$t:menu.printDialog',
    },
    component: () => import('@/pages/bpm/instance/printDialog.vue'),
  },
  // 详情组件用户信息展示
  {
    path: '/bpm/instance/instanceDetailIframe/:id',
    name: 'instanceDetail',
    meta: {
      title: '$t:page.task.proDetails',
    },
    component: () => import('@/pages/bpm/instance/instanceDetailIframe.vue'),
  },

  // 文件预览
  {
    path: '/preview/iframe/:fileType/:id',
    name: 'PreviewIframe',
    meta: {
      title: '$t:page.common.fileDetails',
    },
    component: () => import('@/pages/fileshow/PreviewIframe.vue'),
  },
  {
    path: '/simplewf/oneStopDesign/:id',
    name: 'oneStopDesign',
    meta: {
      title: '$t:menu.processDesigner',
    },
    component: () => import('@/pages/simplewf/simpleWF.vue'),
  },
  {
    path: '/simplewf/oneStopDesign/',
    name: 'oneStopDesignNew',
    meta: {
      title: '$t:menu.newProcess',
    },
    component: () => import('@/pages/simplewf/simpleWF.vue'),
  },

  /* 聊天页面 */
  {
    path: '/MessageCenter',
    name: 'MessageCenter',
    component: () => import('@/communication/MessageCenter'),
  },
]

/**
 * 错误页面
 */

const errorPage = [
  {
    path: '/403',
    name: '403',
    meta: {
      title: '403',
    },
    component: () => import('@/pages/system/error/403'),
  },
  {
    path: '/500',
    name: '500',
    meta: {
      title: '500',
    },
    component: () => import('@/pages/system/error/500'),
  },
  {
    path: '*',
    name: '404',
    meta: {
      title: '404',
    },
    component: () => import('@/pages/system/error/404'),
  },
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage]
